export default {"src":"/_next/static/media/cash.fd817162.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};